/*
  In-page links copied from the old theme point at section ids with the old template number,
  for example #shopify-section-template--29662406672717__main. When the exact id is missing,
  find the section by its suffix (__main) and scroll there smoothly.
*/
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href*="#"]');
    if (!link || link.hasAttribute('data-rl-scroll') || link.classList.contains('skip-to-content-link')) return;
    const url = new URL(link.href, window.location.href);
    if (url.pathname !== window.location.pathname || url.hash.length < 2) return;
    const hash = url.hash;
    let target = null;
    try {
      target = document.querySelector(hash);
    } catch (e) {}
    if (!target && hash.includes('__')) {
      const suffix = hash.split('__').pop();
      target = document.querySelector(`[id^="shopify-section-"][id$="__${CSS.escape(suffix)}"]`);
    }
    if (!target) return;
    event.preventDefault();
    const header = document.querySelector('.section-header');
    const offset = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
    const top = target.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
  });
})();
